import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useNavigate, Link } from 'react-router-dom';
import { useTheme, styled } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import moment from 'moment';
import VisibilityIcon from '@mui/icons-material/Visibility';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  Container,
  Typography,
  IconButton,
  TableContainer,
  Button,
  TableHead,
  TablePagination,
} from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, ActionListToolbar } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/rule';
import { getAclMenu, getToken } from '../utils/common';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '', label: 'Action Name', alignRight: false },
  { id: '', label: 'Description', alignRight: false },
  { id: '', label: 'Date', alignRight: false },
  { id: '', label: 'Author', alignRight: false },
  { id: '', label: 'Aksi', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserPage() {
  const [open, setOpen] = useState(null);
  const [acl, setAcl] = useState(getAclMenu('action'));
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');
  const [data, setData] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const navigate = useNavigate();

  const handleClicks = () => {
    navigate('/dashboard/action/add', { replace: true });
  };

  const handleClicks1 = () => {
    navigate('/dashboard/viewrule', { replace: true });
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    
    fetchInfo(window.REACT_APP_API_PURE + 'action/list?limit=' + rowsPerPage + '&page=' + newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
    fetchInfo(window.REACT_APP_API_PURE + 'action/list?limit=' + parseInt(event.target.value, 10) + '&page=0');
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
    fetchInfo(window.REACT_APP_API_PURE + `action/list?action_name=${event.target.value}`);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  const fetchInfo = (url) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => setData(d));
  };
  useEffect(() => {
    fetchInfo(window.REACT_APP_API_PURE + 'action/list');
  }, []);

  const { t } = useTranslation();

  function handleClickLang(lang) {
    i18next.changeLanguage(lang);
  }
  const [selectedLanguage, setSelectedLanguage] = useState(i18next.language || 'en');
  const handleClickLangs = (language) => {
    setSelectedLanguage(language);
    i18next.changeLanguage(language);
    // You can perform additional actions based on the selected language here
  };

  return (
    <>
      <Helmet>
        <title> Action Management | SmartShield </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('Actions.1')}
          </Typography>
          {!acl?.create ? (
            ''
          ) : (
            <Link to="/dashboard/action/add">
              <Button
                style={{ backgroundColor: 'rgb(79, 138, 226)' }}
                variant="contained"
                startIcon={<Iconify icon="eva:plus-fill" />}
              >
                {t('NewActions.1')}
              </Button>
            </Link>
          )}
        </Stack>

        <Card>
          <ActionListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, borderRadius: 2, border: '1px solid #e0e0e0' }}>
              <Table>
                <TableHead>
                  <TableRow className="custom-table-row">
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Nomor.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('NameActions.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Deskripsyong.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('DateTime.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Author.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Actions.2')}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.data?.map((index, row, dataObj) => {
                    const dateString = moment.unix(index.created_at).format('YYYY-MM-DD HH:mm');

                    return (
                      <TableRow hover key={row}>
                        <TableCell component="th" scope="row" alignItems="center">
                          {row + 1}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          padding="none"
                          style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        >
                          {index.action_name}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          padding="none"
                          style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        >
                          {index.description}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {dateString}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {index.created_by}
                        </TableCell>
                        <TableCell>
                          <Link
                            to={{
                              pathname: `/dashboard/action/edit`,
                            }}
                            state={{ index }}
                            style={{
                              textDecoration: 'none',
                              borderRadius: '20px',
                              border: '1px solid #12A2CE',
                              padding: '6px 16px',
                              color: '#12A2CE',
                              display: 'inline-block',
                              textAlign: 'center',
                              cursor: 'pointer',
                            }}
                          >
                            {t('Edit.1')}
                          </Link>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {/* {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )} */}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data?.total || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleClicks1}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Process
        </MenuItem>
      </Popover>
    </>
  );
}
